<template>
    <brick-square-base>
        <div class="brick-icon">
           <brick-icon :brick-type="brickType" /> 
        </div>
        <div class="brick-title">
            {{displayName}}
        </div>
    </brick-square-base>
</template>

<script>
    import BrickSquareBase from "@modules/JourneyBuilder/Components/Patterns/BrickSquareBase.vue";
    import BrickIcon from "@modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/BrickIcon";

    export default {
        name: 'menu-composable-square-brick',
        components: {
            BrickIcon,
            BrickSquareBase
        },
        props: {
            displayName: {
                type: String,
                required: true
            },
            
            brickType: {
                type: Number,
                required: true
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "~@modules/JourneyBuilder/Style/composable-square-brick.scss";
</style>
